import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query/react"
import { CURRENT_COLLECTION_API_VERSION, AppConfiguration, ConfigKeys } from "src/common";

// NOTE: Leave baseUrl from process.env. as default. These get set in the API files dynamically
export const collectionServerAPI = createApi({
  // NOTE: Dynamically create the baseQuery with values for baseUrl from the store
  baseQuery: async (args, api, extraOptions) => {
    const baseUrl = AppConfiguration.getConfigValue(ConfigKeys.backend_server); //REACT_APP_BACKEND_SERVER
    const prepareHeaders = (headers: Headers) => {
      headers.set("accept-version", CURRENT_COLLECTION_API_VERSION);
      headers.set("Content-Type", "application/json");
      return headers;
    }
    const rawBaseQuery = fetchBaseQuery({ baseUrl, prepareHeaders });
    return rawBaseQuery(args, api, extraOptions);
  },
  reducerPath: "collectionApi",
  tagTypes: ["collection", "mailbox", "threads", "keyval", "gateway", "groups", "org_data", "cloud_lock"],
  endpoints: () => ({}),
});

export const filesyncSocketAPI = createApi({
  // NOTE: Dynamically create the baseQuery with values for baseUrl from the store
  baseQuery: async (args, api, extraOptions) => {
    const baseUrl = AppConfiguration.getConfigValue(ConfigKeys.backend_websocket_server); // REACT_APP_BACKEND_WEBSOCKET_SERVER
    const rawBaseQuery = fetchBaseQuery({ baseUrl });
    return rawBaseQuery(args, api, extraOptions);
  },
  reducerPath: "filesyncSocketApi",
  tagTypes: ["collection_ws", "watch_ws"],
  endpoints: () => ({}),
});

// This will be saved for future development of an open API Config for crypto server
export const cryptoServerAPI = createApi({
  // NOTE: Dynamically create the baseQuery with values for baseUrl from the store
  baseQuery: async (args, api, extraOptions) => {
    const baseUrl = AppConfiguration.getConfigValue(ConfigKeys.crypto_server); // REACT_APP_CRYPTO_SERVER
    const rawBaseQuery = fetchBaseQuery({ baseUrl });
    return rawBaseQuery(args, api, extraOptions);
  },
  refetchOnFocus: true,
  refetchOnReconnect: true,
  reducerPath: "cryptoApi",
  tagTypes: ["crypto"],
  endpoints: () => ({}),
});

export const filesyncServerAPI = createApi({
  // NOTE: Dynamically create the baseQuery with values for baseUrl from the store
  baseQuery: async (args, api, extraOptions) => {
    const baseUrl = AppConfiguration.getConfigValue(ConfigKeys.filesync_server); // REACT_APP_FILESYNC_SERVER
    const rawBaseQuery = fetchBaseQuery({ baseUrl });
    return rawBaseQuery(args, api, extraOptions);
  },
  reducerPath: "filesyncApi",
  tagTypes: ["filesync", "download"],
  endpoints: () => ({}),
});


// This will be saved for future development of an open API Config for crypto server
export const keyStorageServerAPI = createApi({
  // NOTE: Dynamically create the baseQuery with values for baseUrl from the store
  baseQuery: async (args, api, extraOptions) => {
    const baseUrl = AppConfiguration.getConfigValue(ConfigKeys.keystorage_server); // REACT_APP_KEYSTORAGE_SERVER
    const prepareHeaders = (headers: Headers) => {
      headers.set("accept-version", process.env.REACT_APP_KEYSTORAGE_API_VERSION || "v0");
      headers.set("Content-Type", "application/json");
      return headers;
    }
    const rawBaseQuery = fetchBaseQuery({ baseUrl, prepareHeaders });
    return rawBaseQuery(args, api, extraOptions);
  },
  reducerPath: "keystorageApi",
  tagTypes: ["kss"],
  endpoints: () => ({}),
});
